import { render, staticRenderFns } from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=template&id=07c3ae9e&"
import script from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports